import { Pipe, PipeTransform } from "@angular/core";

//import moment from "moment";

@Pipe({
  name: "yesNoTransform",
})
export class YesNoTransformPipe implements PipeTransform {
  /**
   * Takes a datetime and formats it
   */
  transform(value: boolean | string) {
    if (value == null) {
      return "No";
    }
    if (typeof value === "string") {
      value = value.toLowerCase() === "true";
    }
    return value ? "Yes" : "No";
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/yes-no-transform.pipe.ts